<template>
    <el-drawer
        :title="`座位预览（${region && region.regionName}，共${seatData && seatData.list && seatData.list.length || 0}个座位）`"
        :visible.sync="drawerShow"
        :wrapperClosable="false"
        :destroy-on-close="true"
        size="85%"
        @close="close"
        append-to-body
    >
        <div class="drawer-content" v-loading="dataLoading">
            <!-- {{scale}} -->
            <div class="seat-wrap" ref="seatWrap">
                <div class="left-bar">
                    <div class="col"><div></div></div>
                    <div v-for="(row) in maxRow" :key="row" class="col"><div>{{row}}</div></div>
                </div>
                <div class="right">
                    <div class="top-bar row">
                        <div v-for="(col) in maxCol" :key="col" class="col">
                            <div>{{col}}</div>
                        </div>
                    </div>
                    <div class="seat-box">
                        <div v-for="(item,row) in seatMap" :key="row" class="row">
                            <div v-for="(seat,col) in item.seat" :key="col" class="col">
                                <!-- <el-tooltip v-if="seat" effect="dark" :content="seat.fullName">
                                    <div class="shafa"></div>
                                </el-tooltip> -->
                                <el-popover
                                    v-if="seat"
                                    placement="top"
                                    width="200"
                                    trigger="hover"
                                    :content="seat.fullName">
                                    <div slot="reference" class="shafa"></div>
                                </el-popover>
                                <div v-else></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="drawer-footer">
            <el-button @click="close">返回</el-button>
        </div>
    </el-drawer>
</template>

<script>
export default {
    data(){
        return{
            drawerShow: false,
            dataLoading: false,
            params: {
                hallId: "",
                regionId: ""
            },
            maxRow: 50,
            maxCol: 50,
            seatData: null,
            seatMap: [],
            scale: 1,
            region: null
        }
    },
    methods: {
        close() {
            this.seatData = null;
            this.seatMap = [];
            this.drawerShow = false;
        },
        show(hallId,item) {
            this.region = item;
            this.params = {
                hallId: hallId,
                regionId: this.region.regionId
            }
            this.getSeatData();
            this.drawerShow = true;
        },
        // 获取座位数据
        getSeatData(){
            this.dataLoading = true;
            this.$request({
                url: "/site/seatPreviewSeat",
                params: { 
                    ...this.params
                },
                method: "post",
            })
                .then((res) => {
                    const { state, msg, result } = res.data;
                    if (state == 1 && result) {
                        this.seatData = result
                        this.maxCol = Math.max(50, result.colCount);
                        this.maxRow = Math.max(50, result.rowCount);
                        this.formatSeat();
                    }else{
                       this.$message.error(msg || "获取信息失败,请重试"); 
                    }
                })
                .catch(() => {
                    this.$message.error("获取信息失败,请重试");
                })
                .finally(() => {
                    this.dataLoading = false;
                });
        },
        //格式化座位数据
        formatSeat(){
            let _seatMap = [];
            for (let r = 0; r < this.maxRow; r++) {

                let _list = this.seatData.list.filter(v => v.graphRow == r + 1)
                let _name = _list[0] ? _list[0].graphRow : ""
                let _seat = []

                for (let c = 0; c < this.maxCol; c++) {
                    _seat[c] = _list.find(v => v.graphCol == c + 1)
                }

                _seatMap.push({
                    row: _name,
                    seat: _seat
                })
            }
            this.seatMap = _seatMap
            this.setSize();
        },
        setSize(){
            // this.$nextTick(() => {
            //     const w = this.$refs.seatWrap.offsetWidth, h = this.$refs.seatWrap.offsetHeight;
            //     const n1 = Math.max(w, h);
            //     const m = Math.max(this.maxCol, this.maxRow);
            //     const n2 = m * 22;
            //     if(n2 > n1){
            //         this.scale = n1 / n2
            //     }
            // })
        }
    }
}
</script>

<style lang="scss" scoped>
::v-deep .el-drawer{
    max-width: 100%;
}
.seat-wrap{
    display: flex;
    .left-bar{
        padding-right: 10px;
        padding-top: 10px;
    }
    .top-bar{
        padding-bottom: 10px;
    }
    .right{
        overflow-x: auto;
        overflow-y: hidden;
        flex: 1;
    }
    .seat-box{
        // overflow-x: auto;
        // overflow-y: hidden;
        border-left: 1px #eee solid;
        .col{
            border: 1px #eee solid;
            margin: -1px 0 0 -1px;
        }
    }
    .row{
        display: flex;
        flex-wrap: nowrap;
    }
    .col{
        border: 1px transparent solid;
        margin: -1px 0 0 -1px;
        > div, .shafa{
            width: 20px;
            height: 20px;
            font-size: 12px;
            color: #999;
            display: flex;
            align-items: center;
            justify-content: center;
        }
        .shafa{
            // border: 1px #000 solid;
            background: url('~@/assets/img/seat.png') center center no-repeat;
            background-size: 70%;
            &:hover{
                background-image: url('~@/assets/img/seat-selected.png');
            }
        }
    }    
}
</style>